import download from 'downloadjs';

import apiRoutes from '../../../api-routes';
import { initializeWebViewerFromBlob } from '../../../webviewer';
import { getRequest } from '../../../helpers/apiClient';
import { useMutationWithLogout } from '../../../hooks/useMutationWithLogout';

export const useDownloadSingleDocument = (
  id,
  documentTitle,
  isPreview = false,
) =>
  useMutationWithLogout(
    async () => {
      const { data } = await getRequest({
        url: apiRoutes.SINGLE_DOCUMENT_DOWNLOAD.replace('{id}', id),
        responseType: 'arraybuffer',
      });
      return data;
    },
    {
      onSuccess: (response) => {
        const blob = new Uint8Array(response);

        if (isPreview) {
          initializeWebViewerFromBlob(blob, documentTitle + '.pdf');
          return;
        }

        download(blob, documentTitle + '.pdf');
      },
    },
  );
